import { createFileRoute } from '@tanstack/react-router'
import { FlashSalesInventoryLayout } from '@/features/flash-sales/components'

export const Route = createFileRoute('/_authenticated/flash-sales-inventory')({
  component: FlashSalesInventoryLayout,
})
